import React, { Component } from 'react';
// import { Route, Switch, Router, Redirect } from 'react-router-dom';
import PageSwitcher from './Components/PageSwitcher';
import SyncQueue from './Components/SyncQueue';
// import SignUpPage from './Pages/SignUpPage';
// import SignInPage from './Pages/Login/SignInPage';
// import PinConfigurationPage from './Pages/PinConfiguration/PinConfigurationPage';
// import ProspectPage from './Pages/Prospect/ProspectPage';
// import DashboardPage from './Pages/DashboardPage/DashboardPage';
import store from './Redux/store'
// import { HOC } from "react-redux-permissions"
// import NotFound from './Pages/Security/NotFound' 
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core';
import { Provider } from "react-redux"
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import AlertSystem from './Components/AlertSystem';

const baseTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#ED7D31'
        },
        secondary: {
            main: '#31A1ED'
        }
    }
});

export default class App extends Component {

    render() {
        return (
            <Provider store={store}>
                <SyncQueue/>
                <AlertSystem/>
                <ThemeProvider theme={baseTheme}>
                    <ScopedCssBaseline>
                        <PageSwitcher/>
                        {/* <Router history={history}> */}
                            {/* <Switch> */}
                                {/* <Route path="/" exact component={PageSwitcher} /> */}
                                {/* <Route path="/register" component={SignUpPage} /> */}
                                {/* <Route path="/login" component={SignInPage} /> */}
                                {/* <Route path="/configure-pin" component={PinConfigurationPage} /> */}
                                {/* <Route path="/dashboard" component={HOC(["dashboard"])(DashboardPage, <Redirect to='/login'/>)} /> */}
                                {/* <Route path="/:id" exact component={ProspectPage} /> */}
                                {/* <Route component={NotFound} /> */}
                            {/* </Switch> */}
                        {/* </Router> */}
                    </ScopedCssBaseline>
                </ThemeProvider>
            </Provider>
        );
    }
}
